module.exports = __webpack_public_path__ + "img/fr_failure_3.a3185f4d.png";